import { BannerPosition } from '@g99-product-web-ui/shared-interface-lib';

export const TWILIO_BANNER_CONFIG = {
  message:
    'Complete your free 10DLC setup to enable two-way texting for your business.',
  linkText: 'Click here',
  navigateTo: '/business/contact-settings',
  position: BannerPosition.RELATIVE,
};

export const GOOGLE_BANNER_CONFIG = {
  message: 'Your Google Business Profile connection needs to be updated.',
  linkText: 'Reconnect now',
  navigateTo: '/review/location',
  externalLinkText: 'Learn more',
  externalLinkUrl: 'https://support.growth99.com/google-policy',
  position: BannerPosition.RELATIVE,
};

export const TWO_WAY_BANNER_CONFIG = {
  title: 'Two-Way Texting Required',
  message:
    'GIA requires two-way texting to be enabled for your business. Please enable two-way texting in your Contact Settings to activate GIA and start using AI-powered appointment booking and client communication.',
  buttonText: 'Go to Contact Settings',
  navigateTo: '/business/contact-settings',
  position: BannerPosition.RELATIVE,
};

export const GIA_ACTIVATION_BANNER_CONFIG = {
  title: 'GIA Activation Pending',
  subtitle: 'Two-way texting registration required to complete setup',
  buttonText: 'Enable Now',
  navigateTo: '/business/contact-settings',
};

export const HOLIDAY_READY_BANNER_CONFIG = {
  // Change the key for a new campaign so users who closed the last one see it again.
  storageKey: 'holidayReadyBanner2026Closed',
  // The banner is not shown from this moment on.
  endsAt: '2026-11-28T00:00:00',
  badge: 'Black Friday',
  message:
    'Get your site holiday-ready: submit requests 15 business days before go-live.',
  linkText: 'View details',
  title: "Let's get your site holiday-ready",
  intro:
    "You focus on your patients. We'll make sure your site is ready for the Black Friday rush. A few things to keep in mind when submitting requests:",
  facts: [
    {
      icon: 'calendar',
      value: '15',
      unit: 'business days',
      heading: 'Submit early',
      text: 'At least 15 business days before your go-live date, to allow time for feedback and revisions.',
    },
    {
      icon: 'clock',
      value: '8–9',
      unit: 'days',
      heading: 'Build time',
      text: 'Typically 8 to 9 days, depending on scope.',
    },
    {
      icon: 'trend',
      value: 'Plan ahead',
      unit: '',
      heading: 'Traffic spike',
      text: 'Tell us early so we can prep your hosting.',
    },
  ],
  outro:
    "The sooner it's in our hands, the sooner you can stop thinking about it.",
  // The button is shown only once a request link is set.
  ctaText: 'Submit a request',
  ctaUrl: '',
};
